import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        captionText: {
            fontWeight: 500,
            color: theme.palette.text.secondary,
        },
        rightText: {
            marginLeft: 'auto',
        },
        table: {
            marginTop: theme.spacing(1),
            width: '100%',
            cursor: 'pointer',
            borderCollapse: 'collapse',
            '& th': {
                textAlign: 'left',
            },
            '& td': {
                padding: theme.spacing(1),
                border: '1px solid #ccc',
            },
        },
        tableTitle: {
            background: '#c4d8ff',
            transition: 'background .2s ease-in-out',
        },
        tableHeader: {
            display: 'flex',
            width: '100%',
            '&>div': {
                marginRight: theme.spacing(2),
            },
        },
        checkbox: {
            padding: 0,
            margin: '0 8px 0 0',
        },
        selected: {
            background: '#ffe461',
            transition: 'background .2s ease-in-out',
        },
        openIcon: {
            display: 'inline',
            padding: 0,
            margin: '0 10px 0 0',
        },
    })
);
